import React from 'react';
import { QuoteEventRow } from '../types';

/** Render DEPOSIT_RECEIVED quote event text with a bold link on "Deposit Received". */
export function renderQuoteDepositReceivedEventText(
  event: QuoteEventRow,
  onDepositReceivedClick?: () => void
): React.ReactNode {
  const text = (event.eventText || '').trim();
  if (event.eventType !== 'DEPOSIT_RECEIVED' || !onDepositReceivedClick) {
    return text || event.eventType;
  }

  const marker = 'deposit received';
  const lower = text.toLowerCase();
  const idx = lower.indexOf(marker);
  if (idx === -1) {
    return text || event.eventType;
  }

  const before = text.slice(0, idx);
  const after = text.slice(idx + marker.length);

  return (
    <>
      {before}
      <button
        type="button"
        onClick={onDepositReceivedClick}
        className="font-bold underline text-[#0B4778] hover:opacity-80"
      >
        Deposit Received
      </button>
      {after}
    </>
  );
}
